/* Trusted-Shops-Shopbewertung live nachladen, damit überall dieselbe Zahl steht wie im Siegel.
   Ohne Antwort bleibt der Wert aus dem HTML stehen. */
(function () {
  var TSID = 'X1C61E0D54D40C0FEA2BF3352FAD9AAD1';
  var LABELS = { EXCELLENT: 'Hervorragend', GOOD: 'Gut', FAIR: 'Befriedigend', POOR: 'Ausreichend', VERY_POOR: 'Mangelhaft' };

  function apply(indicator) {
    var mark = Number(indicator.overallMark);
    if (!(mark > 0)) return;
    var text = mark.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

    document.querySelectorAll('[data-ts-rating]').forEach(function (el) {
      // Kennzahlen zählen hoch und lesen dafür data-count-to
      if (el.hasAttribute('data-count-to')) el.setAttribute('data-count-to', mark.toFixed(2));
      el.textContent = text;
    });
    document.querySelectorAll('[data-ts-rating-aria]').forEach(function (el) {
      el.setAttribute('aria-label', text + ' von 5 Sternen');
    });
    var label = LABELS[indicator.overallMarkDescription];
    if (label) {
      document.querySelectorAll('[data-ts-rating-label]').forEach(function (el) {
        el.textContent = label;
      });
    }
  }

  function run() {
    fetch('https://api.trustedshops.com/rest/public/v2/shops/' + TSID + '/quality.json')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        var indicator = d && d.response && d.response.data && d.response.data.shop.qualityIndicators.reviewIndicator;
        if (indicator) apply(indicator);
      })
      .catch(function () {});
  }

  if (!document.querySelector('[data-ts-rating],[data-ts-rating-aria],[data-ts-rating-label]')) return;
  if (document.readyState === 'complete') run();
  else window.addEventListener('load', run);
})();
